import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import router from './router';
import ReactGA from 'react-ga4';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

class App extends Component {

  componentDidMount() {

    // ✅ Initialize Google Analytics
    ReactGA.initialize('G-TNRFDW4DB9'); // Replace with your Measurement ID
    // ReactGA.initialize(measurementId);

    this.handleWheel = (e) => {
      const el = document.activeElement;
      if (el?.type === "number" && !el.hasAttribute("data-keep-scroll")) {
        el.blur();
      }
    };

    // ✅ Optional: log initial page load
    // ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.href   // send only the path
    });


    window.addEventListener("wheel", this.handleWheel, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("wheel", this.handleWheel);
  }

  render() {
    return (
      <Provider store={store} >
        {router}
        {/* <ToastContainer /> */}
      </Provider>
    );
  }

}

export default App;
